import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import ServiceCard from "../../../components/ServiceCard";
import {
  FaBalanceScale,
  FaBrain,
  FaBuilding,
  FaCalculator,
  FaEdit,
  FaUserCheck,
  FaUserGraduate,
  FaUsersCog,
} from "react-icons/fa";
type ServiceCardsProps = {};

const ServiceCards: React.FC<ServiceCardsProps> = () => {
  return (
    <Box h="100%" w="100%" align="center" alignSelf="center">
      <Flex w="100%" h="50%" justify="space-between">
        <ServiceCard>
          <Box>
            <Box
              w="10rem"
              h="10rem"
              border="5px solid"
              borderRadius="100%"
              pt={8}
              color="#0ca000"
              // color="#3e9fff"
            >
              <FaBrain size="5rem" />
            </Box>
            <Box h="8rem">
              <Text fontWeight="bold" fontSize="20px" p={2}>
                B-BBEE Consulting
                <br /> and <br />
                turnaround strategies
              </Text>
            </Box>
          </Box>
          <Text justfiy="right">{"Read more >"}</Text>
        </ServiceCard>
        <ServiceCard>
          <Box>
            <Box
              w="10rem"
              h="10rem"
              border="5px solid"
              borderRadius="100%"
              pt={8}
              color="#46c35f"
              // color="#46c35f"
            >
              <FaUserGraduate size="5rem" />
            </Box>
            <Box h="8rem">
              <Text fontWeight="bold" fontSize="20px" p={2}>
                Accredited Training and Development
              </Text>
            </Box>
          </Box>
          <Text justfiy="right">{"Read more >"}</Text>
        </ServiceCard>
        <ServiceCard>
          <Box>
            <Box
              w="10rem"
              h="10rem"
              border="5px solid"
              borderRadius="100%"
              pt={8}
              // color="#00ddc3"
              color="#3e9fff"
              // color="#679436"
              // color="#f86624"
            >
              <FaUserCheck size="5rem" />
            </Box>
            <Box h="8rem">
              <Text fontWeight="bold" fontSize="20px" p={2}>
                Recruitment and Selection
              </Text>
            </Box>
          </Box>
          <Text justfiy="right">{"Read more >"}</Text>
        </ServiceCard>
        <ServiceCard>
          <Box>
            <Box
              w="10rem"
              h="10rem"
              border="5px solid"
              borderRadius="100%"
              pt={8}
              color="#1d8fc3"
              // color="#3e9fff"
              // color="#ffb400"
            >
              <FaBuilding size="5rem" />
            </Box>
            <Box h="8rem">
              <Text fontWeight="bold" fontSize="20px" p={2}>
                Township revitalisation, Entrepreneurship and Incubation Hubs
                (SED)
              </Text>
            </Box>
          </Box>
          <Text justfiy="right">{"Read more >"}</Text>
        </ServiceCard>
      </Flex>
      <Flex w="100%" h="50%" justify="space-between" mt={4} alignSelf="center">
        <ServiceCard>
          <Box>
            <Box
              w="10rem"
              h="10rem"
              border="5px solid"
              borderRadius="100%"
              pt={8}
              // color="#f9f110"
              color="#ffe100"
              // color="#0058cf"
              // color="#3e9fff"
            >
              <FaBalanceScale size="5rem" />
            </Box>
            <Box h="8rem">
              <Text fontWeight="bold" fontSize="20px" p={2}>
                Human Resources and Industrial Relations Consulting
              </Text>
            </Box>
          </Box>
          <Text justfiy="right">{"Read more >"}</Text>
        </ServiceCard>
        <ServiceCard>
          <Box>
            <Box
              w="10rem"
              h="10rem"
              border="5px solid"
              borderRadius="100%"
              pt={8}
              // color="#d5440b"

              color="#f2c012"
            >
              <FaCalculator size="5rem" />
            </Box>
            <Box h="8rem">
              <Text fontWeight="bold" fontSize="20px" p={2}>
                Financial and Payroll Services
              </Text>
            </Box>
          </Box>
          <Text justfiy="right">{"Read more >"}</Text>
        </ServiceCard>
        <ServiceCard>
          <Box>
            <Box
              w="10rem"
              h="10rem"
              border="5px solid"
              borderRadius="100%"
              pt={8}
              color="#d5440b"
              // color="#d5440b"
            >
              <FaUsersCog size="5rem" />
            </Box>
            <Box h="8rem">
              <Text fontWeight="bold" fontSize="20px" p={2}>
                Supply Chain Management
              </Text>
            </Box>
          </Box>
          <Text justfiy="right">{"Read more >"}</Text>
        </ServiceCard>
        <ServiceCard>
          <Box>
            <Box
              w="10rem"
              h="10rem"
              border="5px solid"
              borderRadius="100%"
              pt={8}
              // color="#c70505"
              color="#d5440b"
            >
              <FaEdit size="5rem" />
            </Box>
            <Box h="8rem">
              <Text fontWeight="bold" fontSize="20px" p={2}>
                BEE Codes and Affidavits(Sector Specific)
              </Text>
            </Box>
          </Box>
          <Text justfiy="right">{"Read more >"}</Text>
        </ServiceCard>
      </Flex>
    </Box>
  );
};
export default ServiceCards;
